import { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import ProjectAnalyticsFilter from './components/ProjectAnalyticsFilter';
import { Stack } from '@mui/material';
import ProjectRevenueTable from './components/ProjectRevenueTable';
import TeamSubjectTable from './components/TeamSubjectTable';
import ProjectTrendAnalysisMain from './ProjectTrendAnalysis/ProjectTrendAnalysisMain';
import { useDispatch } from 'react-redux';
// import { getProjects } from '../../../../redux/features/generalSlice';
import { getProjectPerformanceSummary, getWingProjectPivot } from '../../../../redux/features/poinTrackerSlice';
import dayjs from 'dayjs';

const ProjectAnalyticsLanding = () => {
  const [filter, setFilter] = useState({
    fromDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    toDate: dayjs().endOf('month').format('YYYY-MM-DD'),
    project: { id: -1, value: '' },
  });

  const dispatch = useDispatch();
  // useEffects
  /*   useEffect(() => {
    dispatch(getProjects());
  }, [dispatch]) */ useEffect(() => {
    const params = { ...filter, project: filter.project.id === -1 ? null : filter.project.id };
    const wingProjectSignal = dispatch(getWingProjectPivot(params));
    const projectPerformanceSummarySignal = dispatch(getProjectPerformanceSummary(params));
    return () => {
      wingProjectSignal.abort();
      projectPerformanceSummarySignal.abort();
    };
  }, [filter, dispatch]);

  return (
    <GlobalWrapper title={'Project Analysis'}>
      <Stack gap={2}>
        <ProjectAnalyticsFilter filter={filter} setFilter={setFilter} />
        <Stack direction={{ sx: 'column', lg: 'row' }} gap={2}>
          <TeamSubjectTable />
          <ProjectRevenueTable />
        </Stack>
        <ProjectTrendAnalysisMain fromDate={filter.fromDate} toDate={filter.toDate} />
      </Stack>
    </GlobalWrapper>
  );
};

export default ProjectAnalyticsLanding;
